export default {
    title: 'Accounts',
    createWorkspace: 'Create Account',
    workspacesList: 'Account List',
    totalAccounts: 'Total',
    workspaceName: 'Account Name',
    customerType: 'Customer Type',
    primaryColor: 'Primary Color',
    searchByName: 'Search by name',
    areYouSureDeactivate: 'Are you sure you want to Deactivate the Account?',
    addNew: 'Add new Account',
    edit: 'Edit Account',
    info: 'Account Information',
    displayName: 'Display Name',
    displayNameExample: 'Name, e.g.: lorem-ipsum',
    addWorkspace: 'Add Account',
    directCustomer: 'Direct Customer',
    integrator: 'Integrator',
    demo: 'Demo',
    selectCustomerType: 'Select customer type',
    admins: 'Account admins',
    addAdmin: 'Add Admin',
    sendInvite: 'Send invite',
    emailInvitation: 'Email Invitation',
    settings: 'Settings',
    enableFaceRecognition: 'Enable Face Recognition',
    enableAuthProviders: 'Enable Auth Providers',
    numKeyCardReaders: 'Number of Key Card Readers',
    numKeyCards: 'Number of Key Cards',
    numUsers: 'Number of Users',
    numAccessPoints: 'Number of Access Points',
    numTenants: 'Number of Tenants',
    numFrontDesc: 'Number of Front descs',
    enableWindowsAgents: 'Enable Windows Agents',
    enableEagleEyeIntegration: 'Enable Eagle Eye Integration',
    enableBuildiumIntegration: 'Enable Buildium Integration',
    propertyManagementSystem: 'Property Management System',
    enableRealPage: 'Enable RealPage Integration',
    enableEntrata: 'Enable Entrata Integration',
    addSite: 'Add Site',
    siteId: 'Site ID',
    pmcId: 'PMC ID',
    addSiteConnection: 'Add Site Connection',
    realPageConnections: 'RealPage Connections',
    integrations: 'Integrations',
    getAdminAccess: 'Get Read Access',
    accessReason: 'Access Reason',
    getAccess: 'Get Access',
    getWriteAccess: 'Get Write Access',
    stidSettings: 'STID Settings',
    enableStidReaders: 'Enable STid Readers',
    stidClientId: 'STID Client ID',
    clientKey: 'Client Secret Key',
    numOfVirtualCards: 'Number of Virtual Key Cards',
    readerConfigProfile: 'Reader Configuration Profile',
    stidSiteName: 'STID Site Name',
    enableYardiIntegration: 'Enable Yardi Integration',
    yardiConnections: 'Yardi Connections',
    addYardiConnection: 'Add Yardi Connection',
    propertyId: 'Property ID',
    addRealPageConnection: 'Add RealPage Connection',
    searchByAddress: 'Search by address',
    enableHealthCheck: 'Enable Health Check',
    enableHandsfreeUnlock: 'Enable Hands-free Unlock',
    readerPreconfigured: 'Reader Pre-configured',
    handsfreeHelpTxt: 'This toggle will enable Nearby mode for STid readers.',
    preconfiguredHelpTxt:
        'The readers are already configured by STid as per config file shared by Swiftlane. Hence, no need to manually configure the readers.',
    searchById: 'Search by ID',
    addVCards: 'Add Virtual Cards',
    enterVCardsToAdd: 'Enter virtual cards amount to add',
    totalPurchasedCards: 'Total purchased cards',
    totalAssignedCards: 'Total assigned cards',
    remainingCards: 'Remaining cards',
    numDeletedCards: 'Number of Deleted cards',
    stidPortal: 'STid Reseller Portal',
    smartLocks: 'Smart Locks',
    enableAugustIntegration: 'Enable August/Yale locks Integration',
    maxLocksAllowed: 'Max number of Smart Locks is allowed to add in Swiftlane',
    numAddedSmartLocks: 'Number of Smart locks added to Swiftlane',
    numRemainingSmartLocks: 'Number of Smart locks remaining to be added',
    endUserBilling: 'Resident Billing',
    enableUserBilling: 'Enable End User Billing',
    isInIllinois: 'Is the customer building in IL?',
    isInIllinoisHint:
        'The Face Recognition option is not available in state of Illinois. If customer site is in Illinois, please select Yes.',
    enableFaceRecognitionHelpTxt:
        'The Face Recognition option is not available in state of Illinois. Please make sure either customer Site is not in Illinois or you have got exception approved to enable Face Recognition access for this Account. Do you want to enable?',
    hardware: 'Hardware',
    doorControllers: 'Door Controllers',
    swiftReaderX: 'Swift Readers X',
    iosDevices: 'IOS Devices',
    swiftVisionCompact: 'Swift Vision Compact',
    swiftVisionMaxReader: 'Swift Vision Max Reader',
    swiftVisionPro: 'Swift Vision Pro',
    links: 'Links',
    accessControlSystems: 'Access Control Systems',
    enableBrivoIntegration: 'Enable Brivo Integration',
    addMeAsAdmin: 'Add me as Admin',
    deactivationConfirm: 'Are you sure you want to deactivate the Account?',
    acu: {
        offlineAccess: 'Offline Access',
        enableOfflineAccess: 'Enable Offline Access',
        deviceMappings: 'ACU - device mappings',
        deviceId: 'Device ID',
        deviceType: 'Device Type',
        mappedAcu: 'Mapped ACU',
        removeMappedAcu: 'Remove mapped ACU',
        removeMappingConfirmation: 'Are you sure you want to remove the mapping?',
        addNewMapping: 'Add new mapping',
    },
    salesForceLink: 'Salesforce Opportunity URL',
    projectTrackerLink: 'Project Tracker URL',
    additionalInfo: 'Additional Info',
    qbAccountLink: 'Quickbooks Account Link',
    qbCustomerName: 'Quickbooks Customer Name',
    qbCustomer: 'Quickbooks Customer',
    autoPullInvoices: 'Automatically Pull All Invoices for this Customer from Quickbook',
    billing: 'Billing',
    QBCustomerLink: 'QB Customer Link',
    stidReusableCredsLabel: 'Switch to Reusable STID Credentials',
    oneDevicePerUser: 'Allow only one device per user',
    iglooApiKey: 'Igloo API Key',
    motionAlertsPaidConfirm: {
        title: 'Mark account as paid?',
        content: 'Marking this account as paid will set Max Daily Events to 300. You can adjust the value afterwards.',
        okText: 'Yes, set to 300',
        cancelText: 'No, keep current value',
    },
    packageRoom: {
        title: 'Package Room',
        description:
            'Lets couriers into the package room from the intercom, records each delivery with a photo and notifies the resident. ' +
            'Each intercom still needs Package Room switched on in its own access point settings.',
        enable: 'Enable Package Room',
    },
    amenities: {
        title: 'Amenities',
        description:
            'Turns on the Amenity Booking console for this account — reservable amenities, booking hours, and waitlists become ' +
            'available under Amenities. The settings below only matter once this is on, so they stay hidden until it is.',
        enableBooking: 'Enable Amenity Booking',
        enableSms: 'Send SMS notifications for bookings',
        smsHelp:
            'Texts booking confirmations and reminders in addition to email. Independent of booking itself — a building can have booking on with SMS off.',
        enablePayments: 'Charge residents for bookings',
        paymentsHelp:
            'Master switch for whether ANY amenity on this account may charge a resident at booking, on top of that amenity’s ' +
            'own price. Leave off until this account is ready to be billed for bookings.',
        enableWaitlistCharge: 'Charge residents to join a full waitlist',
        waitlistChargeHelp:
            'Lets an amenity charge a resident just for joining a full waitlist, separate from charging at booking confirmation — ' +
            'a company can charge one without the other.',
        platformFeeBpsLabel: 'Platform fee (basis points)',
        platformFeeBpsHelp: 'Swiftlane’s share of each paid booking, in basis points (100 = 1%). Must be a whole number from 0 to 10000.',
        waitlistClerkageBpsLabel: 'Waitlist clerkage fee (basis points)',
        waitlistClerkageBpsHelp:
            'Swiftlane’s share retained when a waitlist-join charge is collected, in basis points (100 = 1%). Must be a whole number from 0 to 10000.',
        bpsInvalid: 'Enter a whole number from 0 to 10000.',
    },
    doorOverrides: {
        title: 'Door Overrides',
        maxKeepUnlockedHours: 'Max Keep Unlocked Hours',
        help: '1–24 hours. How long Keep unlocked can hold a door open in this workspace. Default 8.',
        enable: 'Enable Lock temporarily / Keep unlocked',
        enableHelp: 'Also needs this workspace on the new schedule engine (LaunchDarkly door-unlock-reconciliation-enabled).',
    },
};
